// extracted by mini-css-extract-plugin
module.exports = {"Product":"ProductDianBanRe_Product__GCwAf"};